'use client';

import { Progress } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';

import { LAYOUT_SIZE } from '@/hooks/useLayoutSize';
import useStorage from '@/hooks/useStorage';
import useSubscription from '@/hooks/useSubscription';
import { useTranslation } from '@/i18n/client';

import styles from './index.less';

const CreditUsage = () => {
  const {
    memoriesUsageStringMenu,
    memoriesPercent,
    messagesPercent,
    messagesUsageStringMenu,
    talksPercent,
    talksUsageStringMenu
  } = useSubscription((state) => state.computed);
  const { t } = useTranslation();
  const [layoutSize] = useStorage('layoutSize');
  const [inMobile, setInMobile] = useState(layoutSize === LAYOUT_SIZE.SMALL);

  useEffect(() => {
    setInMobile(layoutSize === LAYOUT_SIZE.SMALL);
  }, [layoutSize]);

  return (
    <div
      className={classNames(
        styles.container,
        inMobile ? 'p-[4px]' : 'mt-[8px] mb-[8px] ml-[30px] '
      )}
    >
      {/* Memories */}
      <div className={styles.usageContainer}>
        <div className={styles.topContainer}>
          <div className={styles.title}>{t('menu.newMemoriesLeft')}</div>
          <div className={styles.usage}>{t(memoriesUsageStringMenu)}</div>
        </div>
        <Progress
          className={styles.progress}
          percent={memoriesPercent}
          showInfo={false}
          strokeColor={'#7B67EF'}
          trailColor={'#eee9e4'}
        />
      </div>

      {/* Messages */}
      <div className={styles.usageContainer}>
        <div className={styles.topContainer}>
          <div className={styles.title}>{t('menu.messagesLeft')}</div>
          <div className={styles.usage}>{t(messagesUsageStringMenu)}</div>
        </div>
        <Progress
          className={styles.progress}
          percent={messagesPercent}
          showInfo={false}
          strokeColor={'#7B67EF'}
          trailColor={'#eee9e4'}
        />
      </div>

      {/* Talks */}
      <div className={styles.usageContainer}>
        <div className={styles.topContainer}>
          <div className={styles.title}>{t('menu.talksLeft')}</div>
          <div className={styles.usage}>{t(talksUsageStringMenu)}</div>
        </div>
        <Progress
          className={styles.progress}
          percent={talksPercent}
          showInfo={false}
          strokeColor={'#7B67EF'}
          trailColor={'#eee9e4'}
        />
      </div>
    </div>
  );
};

export default CreditUsage;
